var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    staticClass: "email-member-modal",
    attrs: {
      "id": "email-modal-btn",
      "centered": true,
      "no-close-on-backdrop": "",
      "size": "sm",
      "title": "Email Categories",
      "hide-footer": true
    },
    on: {
      "shown": _vm.fetchEmailDomains
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "addMemberContent"
  }, [_c('b-form-group', {
    staticClass: "required d-block",
    attrs: {
      "id": "input-group-1",
      "label": "Email address",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-1",
      "type": "email",
      "placeholder": "Enter Email Address",
      "required": "",
      "disabled": ""
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('div', {
    staticClass: "form_checkobox_group mb-2"
  }, [_c('label', {
    staticClass: "form-label-header"
  }, [_vm._v("Select Email Categories:")]), _vm._l(_vm.emailDomains, function (domain) {
    return _c('div', {
      key: domain.value,
      staticClass: "d-flex align-items-center flex-wrap mb-1"
    }, [_c('b-form-checkbox', {
      attrs: {
        "id": `checkbox-${domain.value}`,
        "value": domain.value
      },
      model: {
        value: _vm.selectedDomains,
        callback: function ($$v) {
          _vm.selectedDomains = $$v;
        },
        expression: "selectedDomains"
      }
    }, [_vm._v(" " + _vm._s(domain.text) + " ")]), _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "d-flex flex-shrink-0 ml-1 icon-wrapper",
      attrs: {
        "title": domain.description
      }
    }, [_c('i', {
      staticClass: "fas fa-info-circle"
    })])], 1);
  })], 2), _c('p', {
    staticClass: "text-infos"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" By selecting any of the checkboxes, you will be included in CC emails for the selected email categories. ")])], 1), _c('div', {
    staticClass: "btn-wrapper d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "primaryBtn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Apply")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }